@if (visible) {
  @if (variant === 'badge') {
    <span class="timer-badge" [ngClass]="styleClass">
      <span class="timer-icon"></span>
      <span [innerHTML]="text | safe: 'html'"></span>
    </span>
  } @else {
    <div class="timer-bar" [ngClass]="[styleClass, alignmentClass]">
      <pdq-icon [icon]="icon"></pdq-icon>
      <span [innerHTML]="text | safe: 'html'"></span>
    </div>
  }
}
